import { useMemo } from "react";

import { useMatches } from "@remix-run/react";
import type { DehydratedState } from "@tanstack/react-query";
import merge from "deepmerge";

export const useDehydratedState = (): DehydratedState | undefined => {
    const matches = useMatches();

    return useMemo(() => {
        const dehydratedStateMatches = matches
            .map(
                (match) =>
                    (
                        match.data as
                            | { dehydratedState?: DehydratedState }
                            | undefined
                    )?.dehydratedState,
            )
            .filter((dehydratedState): dehydratedState is DehydratedState =>
                Boolean(dehydratedState),
            );

        if (!dehydratedStateMatches.length) {
            return undefined;
        }

        // AIDEV-NOTE: Memoization keeps the merged dehydrated state referentially stable between renders.
        return dehydratedStateMatches.reduce<DehydratedState>(
            (accumulator, currentValue) => merge(accumulator, currentValue),
            { mutations: [], queries: [] } as DehydratedState,
        );
    }, [matches]);
};
